export default String.raw`
$(document).ready(()=>{
    app.sliderInit(".brands__swiper", ".brands__next", ".brands__prev", ".brands-pause-button");
});
`